import { ContractorListDto } from "../../../core/models/contractors/contractor-list-dto";

//ColumnDef måste spegla nesting för att sortering ska fungera
export const standardColumns = [
  {
    columnDef: 'organisationNumber',
    header: 'Org.nr',
    cell: (element: ContractorListDto) => `${element.organisationNumber}`,
    route: (element: ContractorListDto) => `/contractor/${element.id}`,
  },
  {
    columnDef: 'companyName',
    header: 'Företagsnamn',
    cell: (element: ContractorListDto) => `${element.companyName}`,
  },
  {
    columnDef: 'streetAddress',
    header: 'Adress',
    cell: (element: ContractorListDto) => `${element.streetAddress}`,
  },
  {
    columnDef: 'postalCode',
    header: 'Postnr',
    cell: (element: ContractorListDto) => `${element.postalCode}`,
  },
  {
    columnDef: 'city',
    header: 'Ort',
    cell: (element: ContractorListDto) => `${element.city}`,
  },
  {
    columnDef: 'slaMember',
    header: 'Medlem i SLA',
    cell: (element: ContractorListDto) => `${element.slaMember}`,
  },
  {
    columnDef: 'contractorListStatus',
    header: 'Entreprenörslistan',
    cell: (element: ContractorListDto) => `${element.contractorListStatus}`,
  },
  {
    columnDef: 'contactName',
    header: 'Kontakt',
    cell: (element: ContractorListDto) => `${element.contactName}`,
  },
  {
    columnDef: 'contactPhone',
    header: 'Telefonnr',
    cell: (element: ContractorListDto) => `${element.contactPhone}`,
  },
  {
    columnDef: 'contactEmail',
    header: 'E-post',
    cell: (element: ContractorListDto) => `${element.contactEmail}`,
  },
]

export const contactColumns = [
  {
    columnDef: 'contactRegisterId',
    header: 'Kontaktregister ID',
    cell: (element: ContractorListDto) => `${element.contactRegisterId}`,
    align: 'right'
  },
  {
    columnDef: 'lastModified',
    header: 'Uppdaterad',
    cell: (element: ContractorListDto) => `${element.lastModified}`,
  },
  {
    columnDef: 'performsLogging',
    header: 'Utför föryngringsavverkning',
    cell: (element: ContractorListDto) => `${element.performsLogging}`,
  },
  {
    columnDef: 'performsThinning',
    header: 'Utför gallring',
    cell: (element: ContractorListDto) => `${element.performsThinning}`,
  }
]

export const allColumns = [
  {
    columnDef: 'organisationNumber',
    header: 'Org.nr',
    cell: (element: ContractorListDto) => `${element.organisationNumber}`,
    route: (element: ContractorListDto) => `/contractor/${element.id}`,
    visible: true,
    required: true
  },
  {
    columnDef: 'companyName',
    header: 'Företagsnamn',
    cell: (element: ContractorListDto) => `${element.companyName}`,
    visible: true,
    required: false
  },
  {
    columnDef: 'streetAddress',
    header: 'Adress',
    cell: (element: ContractorListDto) => `${element.streetAddress}`,
    visible: true,
    required: false
  },
  {
    columnDef: 'postalCode',
    header: 'Postnr',
    cell: (element: ContractorListDto) => `${element.postalCode}`,
    visible: true,
    required: false,
    minWidth: 70
  },
  {
    columnDef: 'city',
    header: 'Ort',
    cell: (element: ContractorListDto) => `${element.city}`,
    visible: true,
    required: false
  },
  {
    columnDef: 'slaMember',
    header: 'Medlem i SLA',
    cell: (element: ContractorListDto) => `${element.slaMember}`,
    visible: true,
    required: false
  },
  {
    columnDef: 'contractorListStatus',
    header: 'Entreprenörslistan',
    cell: (element: ContractorListDto) => `${element.contractorListStatus}`,
    visible: true,
    required: false
  },
  {
    columnDef: 'contactName',
    header: 'Kontakt',
    cell: (element: ContractorListDto) => `${element.contactName}`,
    visible: true,
    required: false
  },
  {
    columnDef: 'contactPhone',
    header: 'Telefonnr',
    cell: (element: ContractorListDto) => `${element.contactPhone}`,
    visible: true,
    required: false
  },
  {
    columnDef: 'contactEmail',
    header: 'E-post',
    cell: (element: ContractorListDto) => `${element.contactEmail}`,
    visible: true,
    required: false
  },
  {
    columnDef: 'contactRegisterId',
    header: 'Kontaktregister ID',
    cell: (element: ContractorListDto) => `${element.contactRegisterId}`,
    visible: true,
    required: false,
    align: 'right',
  },
  {
    columnDef: 'lastModified',
    header: 'Uppdaterad',
    cell: (element: ContractorListDto) => `${element.lastModified}`,
    visible: true,
    required: false,
    minWidth: 165

  }
]





